import styled from 'styled-components';

import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';

import {
  borderColor,
  sectionColor
} from '../../../lib/theme';

export const MethodAvatar = styled(Avatar)`
  && {
    background: ${sectionColor};
    color: rgba(0, 0, 0, 0.62);
    width: 32px;
    height: 32px;
  }
`;

// Vertical stack so a mixed-method (EMAIL + SMS) group shows both icons in the
// header without widening the row; single-method groups render one avatar.
export const MethodAvatarGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Subject = styled.span`
  font-weight: 500;
`;

export const EventCard = styled.div`
  border-bottom: 1px solid ${borderColor};
  background: #fff;
`;

export const EventHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 20px;
  cursor: pointer;

  &:hover {
    background: ${sectionColor};
  }
`;

export const EventBody = styled.div`
  background: ${sectionColor};
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`;

// In-progress delivery line (spinner + "Sending — X of N delivered") shown while
// a send event is unsettled, in place of the final result chips.
export const SendingSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
`;

export const ExpandToggle = styled(IconButton)<{ $open: boolean }>`
  && {
    transition: transform 200ms ease;
    transform: rotate(${(p) => (p.$open ? 180 : 0)}deg);
  }
`;

// Sticks to the top of the scrollable Body so the top-level search stays
// reachable while paging through a long list.
export const SearchBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 12px 20px;
  background: #fff;
  border-bottom: 1px solid ${borderColor};
`;

export const PagerBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 8px 20px;
  border-top: 1px solid ${borderColor};
  background: ${sectionColor};
`;

export const ItemSearchBar = styled.div`
  padding: 8px 20px 4px;
`;
